/*
-------------------------------------------------------------------------------------
Authors         : Alinsonorin, John Myl B., Awi, Joseph Kahl L., Gozon, Daniel Allan
Date Created    : Jul 27, 2025
Folder          : src/components/button
File            : ButtonCompDark.tsx
Description     : 
    This reusable component is a dark button.
Copyright © 2025. All rights reserved.
-------------------------------------------------------------------------------------
*/


// Import React Systems
import React, 
        {   ChangeEvent, 
            useState,useRef } from 'react';
import { Link } from "react-router-dom";

// Imports MUI Components
import { 
  TextField,
  Typography,
  Box, 
  Stack,
  Input,
  InputLabel,
  InputAdornment,
  FormControl,
  Tooltip
} from '@mui/material';

// Imports Functions
import { textfieldErrors } from "../../../functions/textfieldErrors";
import Icon from '../../atoms/icon/Icon'

// Imports Assets
import icon from "../../../../assets/icons/search_grey.png"

import "./styles.css"
import { ZAxis } from 'recharts';

const Search = ({
  id,
  label,
  type,
  value,
  color,
  onChange,
  state,
  special,
  search,
  handleSearch,
  searchTerm,
  page
}) => {

  return (
    <div>
      <Tooltip
              title="Search"
              // placement="top"
              arrow
            >
      <Box
        sx={{
          width: {
            xs: "100%",
          },
          display: 'flex',
          alignItems: 'flex-end',
        }}>
                {/* <Box
                  sx={{
                    display: {
                      xs: page === "manageServices" ? "none" : "flex",
                      sm: page === "manageServices" ? "flex" : "flex",
                    },
                    alignItems: "end",
                    alignContent: "end",
                    justifyContent: "end",
                    justifyItems: "end",
                  }}>
        <img
          src={icon}
          alt="icon"
          className={page === "manageServices" ? "small-right-margin" : "small-short-top-margin"}/>
          
          </Box> */}

<TextField 
  id="input-with-sx" 
  value={searchTerm}
  onChange={handleSearch}
  // label="Search"
  placeholder="Search"
  variant="outlined"
  color="search"
  sx={{
    width: "100%",
    "& .MuiFormLabel-root": {
      opacity: searchTerm && searchTerm !== "" ? 0 : 1,
      pointerEvents: searchTerm && searchTerm !== "" ? "none" : "auto",
      transition: "opacity 0.2s ease",
    },
    "& .MuiFormLabel-root.Mui-focused": {
      opacity: 0,
      pointerEvents: "none",
    },
    "& .MuiOutlinedInput-root": {
        fontSize: "14px",
      "& .MuiOutlinedInput-notchedOutline": {
        borderRadius: "100px",
        borderColor: "#2c251e"
      },
      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
        borderColor: "#C5A572",
        backgroundColor: "rgba(44, 37, 30, .1)"
      },
    },
    '& input::placeholder': {
      color: "#2C251E",
      opacity: .6,
      fontSize: "12px",
    },
  }}
  InputProps={{
    sx: {
      fontSize: '17px',
      color: "rgba(30, 32, 44, 1)",
    },
    startAdornment: (
      <InputAdornment position="start">
        <Icon src={icon} size="small-no-margin" />
      </InputAdornment>
    ),
  }}
/>

      </Box>
      </Tooltip>
    
    </div>
  )
}

export default Search
